import React, { Fragment } from "react";

import { shouldAllowSupportChannel } from "base/utils";

import { Intercom, Sentry } from "../common/support_config/support.jsx";

export const SupportChannel = () => {
  if (!shouldAllowSupportChannel()) return null;

  return (
    <Fragment>
      <Intercom />
      <Sentry />
    </Fragment>
  );
};
